import {
    cleanCommonParams,
    mapTagsParams,
} from './common';

const mapAttachmentParams = (
    isCreate,
    {
        resources,
        thumbnail,
        tags,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            attachment: {
                ...cleanCommonParams(params),
                ...mapTagsParams(isCreate, tags),
                thumbnail_id: thumbnail ? thumbnail.id : null,
            },
        });
    });
};

export { mapAttachmentParams };
